@import "@/styles/variables";

.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	padding: 8px 0;
}

.spinnerWrapper {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 64px;
	height: 64px;

	&::before {
		content: "";
		position: absolute;
		width: 64px;
		height: 64px;
		border-radius: 50%;
		background: rgba($primary-color, 0.12);
		animation: pulse 1.5s ease-in-out infinite;
	}
}

.spinner {
	width: 44px;
	height: 44px;
	border-radius: 50%;
	border: 4px solid $gray-200;
	border-top-color: $primary-color;
	animation: spin 0.75s linear infinite;
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}

@keyframes pulse {
	0%,
	100% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(1.25);
		opacity: 0;
	}
}

.message {
	font-size: 0.9375rem;
	font-weight: 600;
	color: $gray-700;
	margin: 0;
	text-align: center;
}

.description {
	font-size: 0.8125rem;
	color: $gray-500;
	margin: 0;
	text-align: center;
	line-height: 1.5;
}
